import type {
  CreateMessageMutation,
  CreateMessageMutationVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import { MESSAGE_FIELDS } from '#src/graphql/fragments/message-fields';

export const CREATE_MESSAGE: TypedDocumentNode<
  CreateMessageMutation,
  CreateMessageMutationVariables
> = gql`
  ${MESSAGE_FIELDS}
  mutation CreateMessage($input: CreateMessageInput!) {
    createMessage(input: $input) {
      ...MessageFields
      childMessages {
        ...MessageFields
      }
    }
  }
`;
